import React from 'react'
import MyPagination from 'components/ui/MyPagination'
import MyRefetchButton from 'components/ui/MyRefetchButton'
import { useForm } from './index'

const DataTableToolbar = ({ mutate, nextAfter }) => {
  const afters = useForm((s) => s.afters)
  const after = useForm((s) => s.after)
  const goAfter = useForm((s) => s.goAfter)

  return (
    <div className="mb-2 flex items-center gap-4">
      <MyPagination
        nextAfter={nextAfter}
        after={after}
        goAfter={goAfter}
        afters={afters}
      />
      <MyRefetchButton onClick={() => mutate()} />
    </div>
  )
}

export default DataTableToolbar
